import { Component, inject } from '@angular/core';
import {TranslationService} from "../../services/translation.service";
import {ApplyIfNotEmptyDirective} from "../../directives/apply-if-not-empty.directive";

@Component({
  selector: 'app-child-user-information',
  templateUrl: './child-user-information.component.html',
  styleUrls: ['./child-user-information.component.css'],
  imports: [
    ApplyIfNotEmptyDirective
  ],
  standalone: true
})
export class ChildUserInformationComponent {
  translationService = inject(TranslationService);

}
